export const isLogin = !!window.localStorage.getItem('token');

export const basename = window.okGlobal.langPath || '';

export const siteObj = window.okGlobal.site || {};

export const defaultSymbol = 'btc_usdt';

export const locale = window.okGlobal.locale || 'en_US';

export const website = window.okGlobal.site.sign;
